'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialGoogleOutline = function IoSocialGoogleOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.9 6.4c1 0.8 2.9 2.4 2.9 5.3 0 2.9-1.6 4.3-3.3 5.6-0.6 0.6-1.2 1.1-1.2 1.9s0.6 1.3 1.1 1.7l1.4 1.1c1.8 1.5 3.3 2.8 3.3 5.6 0 3.6-3.6 7.4-10.5 7.4-5.8 0-8.6-2.7-8.6-5.6 0-1.4 0.8-3.5 3.1-4.9 2.5-1.5 5.9-1.6 7.7-1.8-0.6-0.7-1.3-1.4-1.3-2.6 0-0.7 0.2-1.1 0.4-1.6-0.4 0-0.8 0.1-1.2 0.1-4.2 0-6.7-3.1-6.7-6.2 0-1.8 0.9-3.7 2.6-5.2 2.3-1.9 4.9-2.2 7.1-2.2h8.3l-2.6 1.4h-2.5z m-2.8 17.5c-0.3-0.1-0.5-0.1-0.9-0.1s-2.5 0.1-4.2 0.7c-0.9 0.3-3.5 1.2-3.5 4s2.8 4.9 7.1 4.9c3.9 0 5.9-1.9 5.9-4.3 0-2.1-1.3-3.1-4.4-5.2z m1.2-7.5c0.9-0.9 1-2.2 1-2.9 0-2.8-1.7-7.2-5.1-7.2-1 0-2.2 0.5-2.8 1.3-0.7 0.8-0.9 1.9-0.9 2.9 0 2.7 1.6 7 5 7 1.1 0 2.2-0.5 2.8-1.1z' })
        )
    );
};

exports.default = IoSocialGoogleOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-google-outline.js
// module id = 2926
// module chunks = 168707334958949